import { RefObject, useEffect } from 'react'

type HoverAttrs = {
  'data-js-hover': string
  'data-enter-time': number
  'data-leave-time': number
}

export const hoverAttrs = (enterTime: number, leaveTime: number): HoverAttrs => ({
  'data-js-hover': '',
  'data-enter-time': enterTime,
  'data-leave-time': leaveTime,
})

// enter/leave のアニメーションを最後まで再生してから次の状態に切り替える（in-Pocket の hover.js と同じ挙動）
export const useHoverEffect = (rootRef: RefObject<HTMLElement>): void => {
  useEffect(() => {
    const root = rootRef.current
    if (!root) return

    const cleanups: Array<() => void> = []

    root.querySelectorAll<HTMLElement>('[data-js-hover]').forEach((element) => {
      const enterTime = Number(element.dataset.enterTime)
      const leaveTime = Number(element.dataset.leaveTime)
      let isOver = false
      let isPlaying = false
      let timer: number | undefined

      const startEnter = () => {
        isPlaying = true
        element.classList.add('is-hover')
        timer = window.setTimeout(() => {
          isPlaying = false
          if (!isOver) startLeave()
        }, enterTime)
      }

      const startLeave = () => {
        isPlaying = true
        element.classList.remove('is-hover')
        timer = window.setTimeout(() => {
          isPlaying = false
          if (isOver) startEnter()
        }, leaveTime)
      }

      const onEnter = () => {
        isOver = true
        if (!isPlaying) startEnter()
      }

      const onLeave = () => {
        isOver = false
        if (!isPlaying) startLeave()
      }

      element.addEventListener('mouseenter', onEnter)
      element.addEventListener('mouseleave', onLeave)
      cleanups.push(() => {
        element.removeEventListener('mouseenter', onEnter)
        element.removeEventListener('mouseleave', onLeave)
        window.clearTimeout(timer)
        element.classList.remove('is-hover')
      })
    })

    return () => cleanups.forEach((cleanup) => cleanup())
  }, [rootRef])
}
